import { api } from "./requests";
import { updateSurveyArea, getStoredSurveys, clearStoredSurveys } from "./surveyStorage";

export async function submitNeozone(data: any) {
  try {
    await api.sendNeozone(data);
    console.log("Neozone enviada com sucesso");
  } catch (error) {
    console.warn("Erro ao enviar neozone, salvando no localStorage", error);
    updateSurveyArea("neozone", data);
  }
}

export async function submitOpenzone(data: any) {
  try {
    await api.sendOpenzone(data);
    console.log("Openzone enviada com sucesso");
  } catch (error) {
    console.warn("Erro ao enviar openzone, salvando no localStorage", error);
    updateSurveyArea("openzone", data);
  }
}

export async function submitFinal(data: any) {
  try {
    await api.sendFinal(data);
    console.log("Final enviado com sucesso");
  } catch (error) {
    console.warn("Erro ao enviar final, salvando no localStorage", error);
    updateSurveyArea("final", data);
  }
}

export async function submitStoredSurveys() {
  const stored = getStoredSurveys();

  if (stored.neozone.visitedBooth !== null) {
    await api.sendNeozone(stored.neozone);
  }

  if (stored.openzone.graphics !== null) {
    await api.sendOpenzone(stored.openzone);
  }

  if (stored.final.overallExperience !== null) {
    await api.sendFinal(stored.final);
  }

  clearStoredSurveys();
}